export default {
  countList: [
    '请选择公司常驻人数',
    '50-100人',
    '100-200人',
    '200人以上',
  ],
};



// WEBPACK FOOTER //
// ./src/pages/Application/components/Submit/config.js